export const CONTENT_STACK = [
  {
    title: "Something delicious is on the way",
    subText: "Your content may take a minute or more to generate. Please be patient and do not refresh your screen.",
  },
  {
    title: "Taste-test in progress",
    subText:
      "We're checking that the content meets our Responsible AI criteria. This could take a minute or more, so please don't refresh the page.",
  },
  {
    title: "Baking to perfection",
    subText: "We're hard at work checking information. This could take a minute or more, so please don't refresh the page.",
  },
  {
    title: "Combining ingredients now",
    subText:
      "Good things take time, like generating content. This could take a minute or more, so please refrain from refreshing your screen. ",
  },
  {
    title: "Perfecting the recipe",
    subText:
      "We want to be sure your content aligns with our Responsible AI criteria. This could take a minute or more, so hold tight and don't refresh the page.",
  },
];

export const DEFAULT_LOADER_CONTENT = {
  title: "",
  subText: "",
};

export const UPSCALING_LOADER_CONTENT = {
  title: "UPSCALING IN PROGRESS",
  subText: "This may take up to a minute. Please be patient and do not refresh your screen.",
};

export const USER_MANAGEMENT_LOADER_CONTENT = CONTENT_STACK[2];
